

export default function QuickSightDash() {
    return (
        <>
            <div id="dashboardContainer"></div>
        </>
    );
}